import { render, staticRenderFns } from "./footer-customer-support-contact.vue?vue&type=template&id=b29f2cfe"
import script from "./footer-customer-support-contact.vue?vue&type=script&lang=ts"
export * from "./footer-customer-support-contact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports